var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNews = function SvgNews(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 38.8 40.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:current;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.4,12.5H30.2V5a1.32,1.32,0,0,0-1.3-1.3H3.9A1.4,1.4,0,0,0,2.6,5V33.7a5,5,0,0,0,5,5h25a5,5,0,0,0,5-5v-20A1.29,1.29,0,0,0,36.4,12.5ZM7.6,36.2a2.48,2.48,0,0,1-2.5-2.5V6.2H27.6V33.7a2.77,2.77,0,0,0,.1.9v.2c.1.3.1.6.3.8h0a2.19,2.19,0,0,0,.3.5l-20.7.1Zm27.5-2.4a2.5,2.5,0,0,1-5,0V15h5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.1,10H12.6a1.3,1.3,0,0,0,0,2.6h7.5a1.3,1.3,0,1,0,0-2.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,16.3H8.8a1.3,1.3,0,1,0,0,2.6h15a1.32,1.32,0,0,0,1.3-1.3A1.26,1.26,0,0,0,23.8,16.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,21.2H8.8a1.3,1.3,0,1,0,0,2.6h15a1.3,1.3,0,1,0,0-2.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,26.3H8.8a1.3,1.3,0,0,0,0,2.6h15a1.32,1.32,0,0,0,1.3-1.3A1.26,1.26,0,0,0,23.8,26.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,31.3H8.8a1.3,1.3,0,0,0,0,2.6h15a1.32,1.32,0,0,0,1.3-1.3A1.26,1.26,0,0,0,23.8,31.3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.6,
    cy: 4.8,
    r: 3
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/News.5d7b027d.svg";
export { ForwardRef as ReactComponent };